import instance from '../utils/axios';
import Appconfig from '../config/config';

export const createBanner = async (formData) => {
    return await instance.post('/api/banner/', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const fetchBanners = async (siteCode) => {
    return await instance.post('/api/banner/list', { site_code: siteCode });
};

export const deleteBanner = async (bannerId, siteCode) => {
    return await instance.delete(`/api/banner/${bannerId}`, {
        data: { site_code: siteCode }
    });
};